<template>
  <span>
    <v-breadcrumbs-item
      v-if="!route.meta.breadcrumb.dynamic"
      exact
      :to="{ name: routeName }"
    >
      {{ route.meta.breadcrumb.linkText }}
    </v-breadcrumbs-item>
    <v-breadcrumbs-item
      v-if="route.meta.breadcrumb.dynamic"
      exact
      :to="{ name: routeName, params: { ...route.params } }"
    >
      <template v-if="value">
        {{ formattedValue }}
      </template>
      <template v-if="!value">
        {{ loadingText }}
      </template>
    </v-breadcrumbs-item>
  </span>
</template>

<script>
export default {
  props: {
    route: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedValue() {
      return this.route.meta.breadcrumb.linkText(this.value)
    },
    loadingText() {
      const loadingText = this.route.meta.breadcrumb.loadingText
      return loadingText ?? 'Loading...'
    },
    value() {
      if (this.route.meta.breadcrumb.getter) {
        return this.$store.getters[this.route.meta.breadcrumb.getter]
      } else {
        return null
      }
    },
    routeName() {
      const routeName = this.route.meta.breadcrumb.routeName
      return this.route.name ?? routeName
    },
  },
}
</script>

<style>
</style>